import React from 'react';

class Dropdown extends React.Component {
		static defaultProps = {
		  noEmptyOption: false,
		};

		state = {
		  value: this.props.value ? this.props.value : -1,
		};

		selectOption = (e) => {
		  this.setState({
		    value: e.target.value,
		  });
		  const data = {};
		  data[this.props.name] = e.target.value;
		  this.props.setFormData(data);
		};

		render() {
		  const options = [];
		  if (this.props.placeholder) {
		    options.push(<option value={0} key ="0" disabled>
              {this.props.placeholder}
            </option>);
		  }
		  if (!this.props.noEmptyOption) {
		    const emptyOptionVal = '—';
		    options.push(<option value="0" key="0">{emptyOptionVal}</option>);
		  }
		  for (let i = 0; i < this.props.options.length; i++) {
		    options.push((<option
              value={this.props.options[i][this.props.valueKey]}
              key={i+1}
              {...this.props.options[i].attrs}
		    >
              {this.props.options[i][this.props.label]}
            </option>));
		  }
		  let wrapClass = 'form-group ';
		  if (this.props.wrapClass) {
		    wrapClass += this.props.wrapClass;
		  }
		  if (this.props.errorMsg) {
		    wrapClass += ' error';
		  }
		  return (
            <div className={wrapClass}>
              <div className="form-select">
                <select
                  id={this.props.id}
                  value={this.state.value}
                  className="form-control"
                  name={this.props.name}
                  onChange={this.selectOption}
                >
                  {options}
                </select>
              </div>
              {
                this.props.errorMsg
                ?
                <div className="error">
                  <div className="inner">
                    {this.props.errorMsg}
                  </div>
                </div>
                :
                null
              }
            </div>
          );
        }
}

module.exports = Dropdown;
